import { Wallet, Wrench, BadgeCheck, SlidersHorizontal, BatteryCharging, ShieldCheck } from "lucide-react";
import { IMAGES } from "@/config/site";
import { Reveal, SectionHeading } from "./Motion";

const USPS = [
  { id: "finance", icon: Wallet, title: "Easy Finance", desc: "Bank + private finance, easy EMIs" },
  { id: "service", icon: Wrench, title: "Complete On-site Service", desc: "Survey to service, all by our team" },
  { id: "brands", icon: BadgeCheck, title: "40+ Brands", desc: "Best brand for your budget" },
  { id: "custom", icon: SlidersHorizontal, title: "Customized Solutions", desc: "Designed for your roof and load" },
  { id: "trust", icon: ShieldCheck, title: "16 Years of Trust", desc: "10,000+ families & businesses" },
];

const Usp = ({ u }) => (
  <div data-testid={`usp-card-${u.id}`} className="glass card-lift group h-full rounded-3xl p-7">
    <div className="grid h-14 w-14 place-items-center rounded-2xl bg-gold/10 ring-1 ring-gold/30 transition-transform duration-300 group-hover:scale-110">
      <u.icon className="h-7 w-7 text-gold-ink" />
    </div>
    <h3 className="font-display mt-5 text-2xl font-bold text-navy-900">{u.title}</h3>
    <p className="mt-2 text-lg text-slate-600">{u.desc}</p>
  </div>
);

export const WhyUs = () => (
  <section id="why" data-testid="why-us-section" className="section-pad relative bg-[#FFF4DC]">
    <div className="container-x">
      <SectionHeading eyebrow="Why Anuj Solar" title="Big-Company Trust, Personal Service" />
      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Reveal className="md:col-span-2 lg:col-span-1 lg:row-span-2">
          <div data-testid="usp-card-inverter" className="card-lift group relative h-full min-h-[340px] overflow-hidden rounded-3xl border border-slate-200">
            <img src={IMAGES.battery} alt="High capacity inverter and battery room" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/80 via-navy-950/10 to-transparent" />
            <div className="absolute bottom-0 p-7">
              <div className="grid h-14 w-14 place-items-center rounded-2xl bg-gold">
                <BatteryCharging className="h-7 w-7 text-navy-950" />
              </div>
              <h3 className="font-display mt-5 text-2xl sm:text-3xl font-bold text-white">High-capacity Inverter & Battery</h3>
              <p className="mt-2 text-lg text-slate-200">Heavy-duty backup for large sites</p>
            </div>
          </div>
        </Reveal>
        {USPS.map((u, i) => (
          <Reveal key={u.id} delay={(i % 2) * 0.1}>
            <Usp u={u} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
